module.exports = __webpack_public_path__ + "static/media/kawa.9b27e481.png";